import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as PaymentActions from './payment.actions';
import { PaymentEntity, PaymentState } from './payment.models';

export const PAYMENT_FEATURE_KEY = 'payment';

export interface PaymentPartialState {
  readonly [PAYMENT_FEATURE_KEY]: PaymentState;
}

export const paymentAdapter: EntityAdapter<PaymentEntity> = createEntityAdapter<PaymentEntity>();

export const initialPaymentState: PaymentState = paymentAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const reducer = createReducer(
  initialPaymentState,
  on(PaymentActions.initPayment, (state) => ({ ...state, loaded: false, error: null })),
  on(PaymentActions.loadPaymentSuccess, (state, { payment }) =>
    paymentAdapter.setAll(payment, { ...state, loaded: true }),
  ),
  on(PaymentActions.loadPaymentFailure, (state, { error }) => ({ ...state, error })),
  on(PaymentActions.loadCheckoutInfo, (state, { checkoutInfo }) => ({
    ...state,
    loaded: true,
    checkoutInfo,
  })),
  on(PaymentActions.setLoaded, (state, { loaded }) => ({ ...state, loaded })),
  on(PaymentActions.setPublicKey, (state, { publicKey }) => ({ ...state, publicKey })),
  on(PaymentActions.setAddressBookId, (state, { addressBookId }) => ({
    ...state,
    addressBookId,
  })),
  on(PaymentActions.setReturnUrl, (state, { returnUrl }) => ({ ...state, returnUrl })),
  on(PaymentActions.setPaymentSuccess, (state, { paymentSuccess }) => ({
    ...state,
    paymentSuccess,
  })),
  on(PaymentActions.setPaymentError, (state, { paymentError }) => ({ ...state, paymentError })),

  on(PaymentActions.setPaymentBusinessId, (state, { businessId }) => ({ ...state, businessId })),
);

export function paymentReducer(state: PaymentState | undefined, action: Action) {
  return reducer(state, action);
}
